import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const navItemClass = `text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
    scrolled ? 'text-gray-700 hover:text-green-600' : 'text-gray-700 hover:text-green-600'
  }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-200' : 'bg-white/90 backdrop-blur-sm border-b border-gray-100'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-3.5 flex items-center justify-between">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/28a02ba018e540cb808856dcffc9a7b1/bf08d36ac370f16f9e9d390506ce9cf0.png"
            alt="RemesasVE"
            className="h-9 w-auto object-contain"
          />
        </Link>

        <div className="hidden md:flex items-center gap-7">
          <button onClick={() => scrollTo('comparar')} className={navItemClass}>Comparar</button>
          <button onClick={() => scrollTo('como-funciona')} className={navItemClass}>Cómo Funciona</button>
          <button onClick={() => scrollTo('faq')} className={navItemClass}>Preguntas</button>
          <Link to="/sobre-nosotros" className={navItemClass}>Sobre Nosotros</Link>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => scrollTo('comparar')}
            className="hidden md:block bg-green-600 hover:bg-green-700 text-white text-sm font-bold px-5 py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
          >
            Comparar Ahora
          </button>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-colors hover:bg-gray-100 text-gray-700"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          <button onClick={() => scrollTo('comparar')} className="text-left text-sm font-medium text-gray-700 hover:text-green-600 cursor-pointer">Comparar</button>
          <button onClick={() => scrollTo('como-funciona')} className="text-left text-sm font-medium text-gray-700 hover:text-green-600 cursor-pointer">Cómo Funciona</button>
          <button onClick={() => scrollTo('faq')} className="text-left text-sm font-medium text-gray-700 hover:text-green-600 cursor-pointer">Preguntas</button>
          <Link to="/sobre-nosotros" onClick={() => setMenuOpen(false)} className="text-sm font-medium text-gray-700 hover:text-green-600">Sobre Nosotros</Link>
          <button
            onClick={() => scrollTo('comparar')}
            className="bg-green-600 text-white text-sm font-bold px-5 py-3 rounded-xl cursor-pointer whitespace-nowrap"
          >
            Comparar Ahora
          </button>
        </div>
      )}
    </nav>
  );
}
